import { MediaDisplay } from "@package/ui-wall-components";
import { useFlyoutSearchState } from "../SearchContextProvider/context-flyout-search";
import { SearchViewPosts } from "../SearchViewPosts/SearchViewPosts";
import { SearchViewTags } from "../SearchViewTags/SearchViewTags";

function SearchViewDisplay() {
  const { displayType } = useFlyoutSearchState();
  if (displayType === "tags") {
    return <SearchViewTags />;
  }

  return <SearchViewPosts />;
}

export function SearchContent() {
  const { backgroundColorSecondary, headerMedia } = useFlyoutSearchState();

  return (
    <div
      className="flex flex-col h-full w-full overflow-auto"
      style={{ backgroundColor: backgroundColorSecondary ?? "black" }}
    >
      <div className="flex-0 w-full">
        {headerMedia && <MediaDisplay id={headerMedia} forceFit />}
      </div>
      <div className="flex-1 w-full">
        <div className="relative w-full h-full pt-8">
          <SearchViewDisplay />
        </div>
      </div>
    </div>
  );
}
